import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceManagementCardComponent } from './service-management-card.component';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [ServiceManagementCardComponent],
  imports: [CommonModule, AvatarModule, ButtonModule, ButtonGroupModule, CardModule, DividerModule, SkeletonModule, TagModule, TooltipModule],
  exports: [ServiceManagementCardComponent],
})
export class ServiceManagementCardModule {}
